import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { YearLabel, ContentBodyText, ContentTitle, ContentSubtitle } from './TimelineSlideImage';
import { BackgroundImage } from '../../components/Image';
import { PlayButton } from '../Buttons';
import { getFieldValue, getParsedField } from '../../utils/helpers';
import { isFieldValid } from '../../utils/validation';
import { VideoLightbox } from '../../components/Video';
import media from '../../utils/media';
import { detectEscape, setYearFocus, useMobile } from './Timeline._helpers';
import { SCREEN_WIDTH } from '../../utils/media';
import { ScrollDownIcon } from '../Icon';
const Container = styled.section `
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);

  ${media.mobile} {
    padding: 30px;
    min-width: 100vw;
  }
`;
const ContainerIcon = styled.div `
  position: absolute;
  left: 50%;
  margin-left: -17px;
  bottom: 30px;

  ${media.tablet} {
    display: none;
  }
`;
const TextContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 540px;

  &:focus {
    outline: none;
  }
`;
const StyledSubtitle = styled(ContentSubtitle) `
  color: ${({ theme }) => theme.primaryWhite};
`;
const TimelineSlideVideo = ({ fields, years, contentWidth, }) => {
    const { contentSubtitle, contentTitle, contentBodyText, desktopImage, mobileImage, video, ariaLabel, } = fields;
    const [isVideoOpen, setIsVideoOpen] = useState(false);
    const [setEscape, setSetEscape] = useState(false);
    const parsedTitle = getParsedField(contentTitle);
    const parsedSubtitle = getParsedField(contentSubtitle);
    const parsedBodyText = getParsedField(contentBodyText);
    const escapeCheck = (evt) => {
        if (setEscape && detectEscape(evt)) {
            evt.preventDefault();
            setYearFocus(years.id || '');
        }
    };
    useEffect(() => {
        const isMobile = useMobile(contentWidth || 0, SCREEN_WIDTH.MOBILE) || false;
        setSetEscape(isMobile);
    }, []);
    return (React.createElement(Container, { "data-decade": years.decade, "data-year": years.year, "data-id": years.id, onKeyDown: escapeCheck, "aria-label": ariaLabel && ariaLabel.value },
        React.createElement(BackgroundImage, { "aria-label": getFieldValue(desktopImage, 'alt'), desktopImage: desktopImage, mobileImage: mobileImage }),
        React.createElement(VideoLightbox, { isOpen: isVideoOpen, onClose: () => setIsVideoOpen(false), 
            // TODO: Finalize aria-label approach app-wide
            closeIconLabel: 'Close Lightbox', videoLabel: 'Video', video: video, videoHeight: 70, isContained: false }),
        React.createElement(TextContainer, null,
            !!years.year && React.createElement(YearLabel, { field: { value: years.year }, asWhite: true }),
            isFieldValid(contentSubtitle) && React.createElement(StyledSubtitle, { field: parsedSubtitle }),
            isFieldValid(contentTitle) && React.createElement(ContentTitle, { field: parsedTitle, asWhite: true }),
            isFieldValid(contentBodyText) && React.createElement(ContentBodyText, { field: parsedBodyText, asWhite: true }),
            isFieldValid(video, 'url') && (React.createElement(PlayButton, { onClick: () => {
                    setIsVideoOpen(true);
                } }))),
        React.createElement(ContainerIcon, null,
            React.createElement(ScrollDownIcon, { isWhite: true }))));
};
export default TimelineSlideVideo;
